import { Loader2 } from "lucide-react";
import { cn } from "@/shared/utils/cn";

interface LoadingStateProps {
  message?: string;
  className?: string;
}

export function LoadingState({ message, className }: LoadingStateProps) {
  return (
    <div
      className={cn(
        "flex h-full min-h-[200px] w-full flex-col items-center justify-center gap-3 text-muted-foreground",
        className
      )}
    >
      <Loader2 className="h-8 w-8 animate-spin" />
      {message && <p className="text-sm">{message}</p>}
    </div>
  );
}
